import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'normalizeHtml', standalone: true })
export class NormalizeHtmlPipe implements PipeTransform {
  transform(value?: string | null): string {
    if (!value) return ''
    return value.replace(/(&nbsp;|&#160;|\u00A0)/g, ' ').replace(/\s{2,}/g, ' ')
  }
}
